interface domData {
    x: number;
    y: number;
    w: number;
    h: number;
}

class FloatPopPositionFit {
    screenTop: number;
    screenLeft: number;
    screenBottom: number;
    screenRight: number;
    windowWidth: number;
    windowHeight: number;
    direct: string; // 记录一级弹窗展开方向

    constructor(obj) {
        this.screenTop = 0;
        this.screenLeft = 0;
        this.screenBottom = 0;
        this.screenRight = 0;
        this.windowWidth = 0;
        this.windowHeight = 0;
        this.direct = "bottom";
    }

    initData(obj) {
        let key = Object.keys(obj);
        for (let item of key) {
            this[item] = obj[item];
        }
    }

    getTopValid(parent: domData, child: domData) {
        return parent.y - child.h > this.screenTop;
    }

    getRightValid(parent: domData, child: domData, inner: boolean) {
        const pageW = this.windowWidth - this.screenLeft - this.screenRight;
        return inner ? child.x + child.w < pageW : parent.x + parent.w + child.w < pageW;
    }

    getBottomValid(parent: domData, child: domData) {
        const pageH = this.windowHeight - this.screenBottom;
        return parent.y + parent.h + child.h < pageH;
    }

    getLeftValid(parent: domData, child: domData, inner: boolean) {
        return inner ? child.x > this.screenLeft : parent.x - child.w > this.screenLeft;
    }

    checkLv1Position(parent: domData, child: domData, iconPosition: number) {
        // 获取一层级弹窗位置, iconPosition 0为左icon，1为右icon
        const pageW = this.windowWidth - this.screenLeft - this.screenRight;
        const pageH = this.windowHeight - this.screenBottom;
        const topValid = this.getTopValid(parent, child),
            bottomValid = this.getBottomValid(parent, child),
            inner = topValid || bottomValid,
            leftValid = this.getLeftValid(parent, child, inner),
            rightValid = this.getRightValid(parent, child, inner);
        let position = [],
            direct = "bottom";
        if (bottomValid) {
            if (child.x + child.w < pageW) {
                position = [child.x, child.y];
                direct = "bottom";
            } else {
                position = [pageW - child.w, child.y];
                direct = "bottom";
            }
        } else if (topValid) {
            if (child.x + child.w < pageW) {
                position = [child.x, parent.y - child.h];
                direct = "top";
            } else {
                position = [pageW - child.w, parent.y - child.h];
                direct = "top";
            }
        } else if (leftValid && rightValid) {
            const aboveHorizontal = parent.y + parent.h / 2 < this.screenTop + (pageH - this.screenTop) / 2;
            if (!iconPosition) {
                position = [parent.x - child.w, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
                direct = "left";
            } else {
                position = [parent.x + parent.w, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
                direct = "right";
            }
        } else if (leftValid) {
            const aboveHorizontal = parent.y + parent.h / 2 < this.screenTop + (pageH - this.screenTop) / 2;
            position = [parent.x - child.w, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
            direct = "left";
        } else if (rightValid) {
            const aboveHorizontal = parent.y + parent.h / 2 < this.screenTop + (pageH - this.screenTop) / 2;
            position = [parent.x + parent.w, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
            direct = "right";
        }
        this.direct = direct;
        return position;
    }

    checkLv2Position(parent: domData, child: domData) {
        const pageW = this.windowWidth - this.screenLeft - this.screenRight;
        const pageH = this.windowHeight - this.screenBottom;
        const aboveHorizontal = parent.y + parent.h / 2 < this.screenTop + (pageH - this.screenTop) / 2;
        const leftExpandArea = parent.x - child.w,
            rightExpandArea = child.x + child.w,
            bottomExpandArea = child.y + child.h;
        console.log(this.direct);
        if (this.direct != "left") {
            if (rightExpandArea < pageW) {
                if (bottomExpandArea < pageH) {
                    return [child.x, child.y];
                } else {
                    return [child.x, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
                }
            } else {
                if (bottomExpandArea < pageH) {
                    return [pageW - child.w, child.y];
                } else {
                    return [pageW - child.w, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
                }
            }
        } else {
            if (leftExpandArea > this.screenLeft) {
                if (bottomExpandArea < pageH) {
                    return [parent.x - child.w, child.y];
                } else {
                    return [parent.x - child.w, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
                }
            } else {
                if (bottomExpandArea < pageH) {
                    return [this.screenLeft, child.y];
                } else {
                    return [this.screenLeft, aboveHorizontal ? this.screenTop : pageH - this.screenBottom - child.h];
                }
            }
        }
    }
}

export var floatPopPositonFit = new FloatPopPositionFit({});
